import React from "react";
import { toast } from "react-toastify";
const TOAST_MESSAGE_TIMEOUT = 4000;
const Content = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ms-3", dir: (props.locale == 'ar') ? 'rtl' : 'ltr' },
            React.createElement("div", { className: "d-flex flexSpaceBetween fw-bold fs-1" }, props.title),
            React.createElement("ul", { style: { listStyle: '' } }, props.description && (Array.isArray(props.description) ? props.description.map((desc, _index) => React.createElement("li", { className: "mt-1 fs-3", key: _index }, desc)) : React.createElement("p", { className: "mt-1 fs-3" }, props.description))))));
};
export const toastError = (err, lang) => {
    toastify({
        severity: "error",
        title: lang === "ar" ? "حدث خطأ. يرجى المحاولة مرة أخرى أو الاتصال بنا للمساعدة." : "Something went wrong. Please try again or contact us for help.",
        locale: lang
    });
};
export const toastify = (props) => {
    let { autoClose = TOAST_MESSAGE_TIMEOUT, title, description, severity, locale, onClose = null, } = props;
    onClose = onClose || function () { };
    const alertConfig = {
        theme: "dark",
        position: toast.POSITION.TOP_CENTER,
        autoClose,
        onClose,
        rtl: locale === "ar",
    };
    const defaultText = title;
    switch (severity) {
        case "success":
            return toast.success(React.createElement(Content, { title: defaultText, description: description, locale: locale }), alertConfig);
        case "error":
            return toast.error(React.createElement(Content, { title: defaultText, description: description, locale: locale }), alertConfig);
        case "warning":
            return toast.warning(React.createElement(Content, { title: defaultText, description: description, locale: locale }), alertConfig);
    }
};
